import { Sheet, VStack } from '@hover/blueprint';
import React from 'react';
import { useHistory } from 'react-router';

import { useOnboardingSplit } from 'src/modules/onboarding/hooks/useOnboardingSplit';
import { ButtonLink } from 'src/shared/components';
import { urlWithRedirectTo } from 'src/shared/helpers/routing';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { useGlobalStorageContext } from 'src/shared/hooks/useGlobalStorage';
import { Route } from 'src/shared/route';

import { useHomeownerAppContext } from '../../hooks';
import type { WelcomeAction } from '../WelcomeSheet';
import { storeWelcomeAction } from '../WelcomeSheet';

const SignInSheet = () => {
  const t = useTranslate([
    TranslationNamespace.HOMEOWNER_APP,
    TranslationNamespace.COMMON,
  ]);

  const history = useHistory();

  const { showOnboardingSignup } = useOnboardingSplit();

  const { setHomeownerAppUploadFile, setHomeownerAppIsUserHomeowner } =
    useGlobalStorageContext();
  const { trackingData, imageFileToUpload, setImageFileToUpload } =
    useHomeownerAppContext();

  const handleSubmit = (action: WelcomeAction) => {
    storeWelcomeAction(action);
    if (imageFileToUpload) {
      setHomeownerAppUploadFile(imageFileToUpload);
      setImageFileToUpload();
    }

    setHomeownerAppIsUserHomeowner(true);
  };

  return (
    <Sheet.Contents header={t('signInSheet.header')}>
      <VStack align="stretch" py="500" spacing={400}>
        <ButtonLink
          onClick={() => handleSubmit('login')}
          optionalTrackingProperties={{
            ...trackingData,
            track_id: 'log-in',
            link_location: 'bottom-main-page',
          }}
          to={urlWithRedirectTo(Route.LOGIN.path, history.location.pathname)}
          variant="primary"
          width="100%"
        >
          {t('logIn')}
        </ButtonLink>
        <ButtonLink
          onClick={() => handleSubmit('signup')}
          optionalTrackingProperties={{
            ...trackingData,
            track_id: 'sign-up',
            link_location: 'bottom-main-page',
          }}
          to={urlWithRedirectTo(
            showOnboardingSignup
              ? `${Route.SIGN_UP_ONBOARDING.path}/signup`
              : Route.SIGN_UP_HOMEOWNER.path,
            history.location.pathname,
          )}
          variant="tertiary"
          width="100%"
        >
          {t('signUp')}
        </ButtonLink>
      </VStack>
    </Sheet.Contents>
  );
};

export { SignInSheet };
